import { render, staticRenderFns } from "./TenantMultiple.vue?vue&type=template&id=2db06cb6&scoped=true&"
import script from "./TenantMultiple.vue?vue&type=script&lang=js&"
export * from "./TenantMultiple.vue?vue&type=script&lang=js&"
import style0 from "./TenantMultiple.vue?vue&type=style&index=0&id=2db06cb6&scoped=true&lang=css&"
import style1 from "./TenantMultiple.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db06cb6",
  null
  
)

export default component.exports